import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface ChangePasswordModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (oldPassword: string, newPassword: string) => Promise<void>;
  isProfileEdit: boolean; // Flag to identify profile edit
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  show,
  onClose,
  onSubmit,
  isProfileEdit,
}) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handlePasswordSubmit = async () => {
    setErrorMessage(""); // Clear previous errors
  
    // Client-side validation
    if (newPassword !== confirmNewPassword) {
      setErrorMessage("Hasła nie są identyczne!");
      return;
    }
  
    try {
      // Submit the password change
      await onSubmit(oldPassword, newPassword);
  
      // Success handling
      setOldPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
      setErrorMessage("");
      onClose();
    } catch (error) {
      // Cast error to 'any' or 'Error' type to safely access properties
      const err = error as Error; // Cast the error object
  
      console.error("Błąd podczas zmiany hasła:", err.message);
  
      // Extract error message from server response or fallback
      const errorMsg = err.message || "Wystąpił błąd podczas zmiany hasła.";
      setErrorMessage(errorMsg); // Show inline error
    }
  };
  

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Zmień hasło</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {isProfileEdit && (
            <Form.Group controlId="formOldPassword">
              <Form.Label>Stare hasło</Form.Label>
              <Form.Control
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
              />
            </Form.Group>
          )}
          <Form.Group controlId="formNewPassword" className="mt-3">
            <Form.Label>Nowe hasło</Form.Label>
            <Form.Control
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="formConfirmNewPassword" className="mt-3">
            <Form.Label>Potwierdź nowe hasło</Form.Label>
            <Form.Control
              type="password"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              required
            />
          </Form.Group>
          {errorMessage && <p className="text-danger mt-3">{errorMessage}</p>}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Anuluj
        </Button>
        <Button variant="primary" onClick={handlePasswordSubmit}>
          Zmień hasło
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePasswordModal;